import React from"react";export var Check=function Check(){return/*#__PURE__*/React.createElement("i",{className:"fal fa-check"});};